import * as React from 'react';

const Cover = (props: any) => {
	return (
		<svg
			viewBox="-1824.058 -1040.374 4799.999 1800"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<defs>
				<clipPath clipPathUnits="userSpaceOnUse" id="a">
					<path d="M20012.4 6111h-4219.2v2107.8h4219.2z" />
				</clipPath>
			</defs>
			<path
				d="M36000 18840H0h36000"
				style={{
					fill: '#e0d6c3',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M7280.3 5014.6s-144.77 89.6-192.72 291.2c-47.96 201.7-224.43 183.9-253.7 86.9-29.27-97 61.37-296 446.42-378.1M7469.93 5004.7s-54.4 161.3 37.29 347.2c91.7 185.9-55.57 284.7-139.97 228.7s-141.56-267.2 102.68-575.9M7465.37 4980.5s-141.79-94.1-183.18-297.2c-41.39-203.2-218.35-191.1-250.74-95.1-32.41 96 51.74 297.9 433.92 392.3M7810.36 4880.4s-141.79-94.2-183.18-297.3c-41.39-203.1-218.35-191-250.75-95.1-32.4 96 51.75 297.9 433.93 392.4M8096.21 4710.6s-141.79-94.1-183.18-297.3c-41.39-203.1-218.35-191-250.74-95-32.41 96 51.74 297.9 433.92 392.3M8440.92 4485.3s-141.79-94.2-183.19-297.3c-41.39-203.1-218.34-191-250.74-95.1-32.4 96 51.75 297.9 433.93 392.4M7807.17 4880.7s-54.41 161.3 37.29 347.2c91.69 185.9-55.58 284.7-139.98 228.7-84.4-56-141.56-267.2 102.69-575.9M8134.79 4704s-54.4 161.2 37.29 347.1c91.69 186-55.58 284.8-139.98 228.8-84.4-56-141.55-267.2 102.69-575.9M8446.43 4498s-54.4 161.3 37.29 347.2c91.7 185.9-55.58 284.8-139.98 228.7-84.4-56-141.55-267.1 102.69-575.9"
				style={{
					fill: '#ebccb9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M9561.62 3347.4c-7.75-3.8-17.31-1.4-22.28 5.9-2.43 3.6-247.73 363.9-656.62 749.5-376.65 355.2-973.2 805.2-1676.21 932-9.56 1.7-15.91 10.8-14.19 20.4 1.73 9.6 10.88 15.9 20.44 14.2 711.78-128.3 1314.46-582.8 1694.7-941.5 411.52-388.3 658.58-751.2 661.02-754.9 5.45-8 3.32-18.9-4.73-24.4-.68-.4-1.4-.9-2.13-1.2M8828.93 6659.9s-134.09 245.5-38.72 572.6c95.38 327.1-171.23 445.1-291.87 330.3-120.63-114.7-152.9-472.8 330.59-902.9M9091.79 6491.6s53.34 274.6 335.43 465.7c282.09 191.1 151.99 452-14.12 440.5-166.11-11.4-419.36-266.6-321.31-906.2M9065.63 6460.7s-279.1-19.3-503.31-275.8c-224.2-256.6-467.22-95.5-435.51 67.9 31.71 163.5 316.02 383.6 938.82 207.9M9477.15 6037.3s-279.1-19.3-503.31-275.9c-224.21-256.6-467.22-95.5-435.51 68 31.7 163.4 316.01 383.5 938.82 207.9M9747.61 5562.4s-279.1-19.3-503.31-275.8c-224.21-256.6-467.22-95.6-435.51 67.9 31.71 163.5 316.01 383.6 938.82 207.9M10057 4960.3s-279.12-19.3-503.33-275.9c-224.21-256.5-467.22-95.5-435.51 68 31.71 163.5 316.01 383.6 938.84 207.9M9472.84 6040.3s53.34 274.6 335.43 465.7c282.13 191.1 152 452-14.11 440.6-166.12-11.5-419.37-266.7-321.32-906.3M9797.32 5521.6s53.34 274.6 335.48 465.7c282 191.1 152 452-14.2 440.6-166.08-11.5-419.33-266.7-321.28-906.3M10075.2 4974.1s53.4 274.6 335.5 465.7c282 191.1 152 452-14.2 440.6-166.1-11.5-419.33-266.7-321.3-906.3"
				style={{
					fill: '#ebccb9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m10612.1 3388.7-58.2-4.8c-45.2 204.1-103 431.3-176.5 670.9-84.1 274.2-195.1 584-339.8 903.2-1.3 2.9-2.6 5.8-4 8.7-89.28 196.3-191.42 396-307.9 593-2.02 3.5-4.11 7-6.13 10.4-92.19 155.1-193.26 308.5-303.99 457.1-8.04 10.8-16.13 21.6-24.36 32.3-104.87 138.4-218.28 272.3-340.87 399.5-2.61 2.7-5.21 5.4-7.82 8.1-71.36 73.7-145.9 145.1-223.62 213.7a3910.21 3910.21 0 0 1-79.02 67.8c-12.31 10.2-13.92 28.5-3.7 40.7 10.28 12.3 28.45 13.9 40.76 3.7 1.66-1.4 3.39-2.8 5.05-4.2 108.69-91.1 211.44-187.5 308.4-288.1.98-.9 1.89-1.9 2.81-2.8 137.25-142.5 263.06-293.4 378.38-449.2.79-1.1 1.59-2.1 2.39-3.2 116.28-157.4 221.89-319.8 317.65-483.9 3.66-6.3 7.34-12.6 10.95-18.9 98.34-169.8 186.19-341.3 264.52-510.5 5-10.7 10-21.3 14.8-32 150.2-328.5 264.8-647.8 351.2-929.7 74.7-243.8 133.3-474.7 179-681.8"
				style={{
					fill: '#ebccb9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M17862.1 4606.3c-1090.7 0-2010.5-731.5-2295.7-1730.6h4591.4c-285.2 999.1-1205 1730.6-2295.7 1730.6"
				style={{
					fill: '#f4f0e9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15175.5 4070c-752.6 0-1387.4-504.8-1584.2-1194.3h3168.5C16563 3565.2 15928.2 4070 15175.5 4070M18590.2 2875.7c308.4 1066.9 1530.3 1863.9 2990.9 1863.9 1460.6 0 2682.5-797 2990.9-1863.9h-5981.8"
				style={{
					fill: '#f4f0e9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M26381 1745.8H9619.04c-309.75 0-560.89 251.1-560.89 560.8 0 309.8 251.14 560.9 560.89 560.9H26381c309.7 0 560.8-251.1 560.8-560.9 0-309.7-251.1-560.8-560.8-560.8"
				style={{
					fill: '#bcd2d9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M25059.2 5612.9c85.4-183 286.9-269.6 286.9-269.6s63 210.1-22.4 393.1c-85.4 182.9-286.9 269.5-286.9 269.5s-63-210.1 22.4-393M24669.6 4789.8c114.6-166.3 327.7-218.3 327.7-218.3s27.3 217.7-87.3 383.9c-114.5 166.3-327.6 218.3-327.6 218.3s-27.3-217.6 87.2-383.9M25842.9 6196.6c-134.5-150.7-134.6-370-134.6-370s217.9 25 352.4 175.6c134.4 150.7 134.5 370 134.5 370s-217.9-24.9-352.3-175.6M25696.6 5496.4c-201.7-9.4-358.4-162.9-358.4-162.9s170.3-138.2 372-128.7c201.7 9.4 358.4 162.9 358.4 162.9s-170.3 138.1-372 128.7M25357.2 4739.1c-201.7-9.4-358.4-162.9-358.4-162.9s170.3-138.1 372-128.7c201.7 9.4 358.4 162.9 358.4 162.9s-170.3 138.2-372 128.7"
				style={{
					fill: '#999',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m24676.8 2966.6 41.1-.2c.1 4.8 4.6 483.7 143.3 1085.6 81.4 353.1 192.3 678.8 329.7 968 171.4 360.9 384.9 665.7 634.3 905.9l-28.6 29.6c-253.1-243.8-469.5-552.8-643.1-918.4-138.7-292-250.6-620.7-332.6-976.8-139.5-606.1-144-1088.9-144.1-1093.7M26585.2 4874.7c-.2-173.8 125.4-314.8 125.4-314.8s125.8 140.8 125.9 314.6c.2 173.9-125.4 314.9-125.4 314.9s-125.8-140.8-125.9-314.7M25981.1 4375c28.7-171.5 175.9-289.8 175.9-289.8s100.7 159.8 72 331.2c-28.7 171.5-175.9 289.8-175.9 289.8s-100.7-159.8-72-331.2M27409.3 5044.1c-159.8-68.5-239.9-239.5-239.9-239.5s179-60 338.8 8.4c159.8 68.5 239.9 239.5 239.9 239.5s-179 60-338.8-8.4M27039.7 4551.4c-160.7 66.2-338.9 3.7-338.9 3.7s82.5-169.9 243.2-236.1c160.7-66.2 338.9-3.7 338.9-3.7s-82.4 169.9-243.2 236.1M26498.8 4084.6c-160.7 66.2-338.9 3.7-338.9 3.7s82.4-169.9 243.2-236.1c160.7-66.2 338.9-3.7 338.9-3.7s-82.5 169.9-243.2 236.1"
				style={{
					fill: '#999',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m25321.6 2950.6 32-15.2c1.7 3.7 180 375.5 507.7 794.3 192.3 245.7 397.6 459.2 610.3 634.6 265.4 218.9 543 378.7 825.1 475.1l-11.4 33.5c-286.4-97.8-567.8-259.8-836.6-481.6-214.7-177.1-421.9-392.6-615.8-640.4-329.9-421.8-509.5-796.6-511.3-800.3M24319.3 3434.4c-546.4 0-1007.1-366.4-1150-866.9h2299.9c-142.8 500.5-603.6 866.9-1149.9 866.9"
				style={{
					fill: '#999',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22973.5 3165.8c-377 0-695-252.9-793.6-598.3h1587.2c-98.6 345.4-416.5 598.3-793.6 598.3M24684 2567.5c154.5 534.5 766.6 933.7 1498.2 933.7 731.7 0 1343.7-399.2 1498.2-933.7H24684"
				style={{
					fill: '#999',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M31466.3 7396.5c261.2 0 481.6-175.2 549.9-414.5h-1099.8c68.3 239.3 288.6 414.5 549.9 414.5M28785.9 7592.7c384.9 0 709.4-258.2 810.1-610.7h-1620.2c100.6 352.5 425.2 610.7 810.1 610.7"
				className={'cloud'}
				style={{
					fill: '#ffffff',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M31299.9 6982c-124.2 429.8-616.5 750.8-1204.8 750.8-588.4 0-1080.7-321-1204.9-750.8h2409.7"
				className={'cloud'}
				style={{
					fill: '#ffffff',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11178.1 12850.6c538.1 0 992-361 1132.7-854h-2265.4c140.7 493 594.5 854 1132.7 854M5656.98 13254.6c792.76 0 1461.32-531.7 1668.59-1258H3988.38c207.27 726.3 875.83 1258 1668.6 1258"
				style={{
					fill: '#fff',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M10835.4 11996.6c-255.9 885.4-1269.81 1546.7-2481.78 1546.7-1211.97 0-2225.89-661.3-2481.75-1546.7h4963.53"
				style={{
					fill: '#eee',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				className={'cloud2'}
				d="M9543.02 12199.2c276.63 0 509.88-185.5 582.28-438.9H8960.76c72.32 253.4 305.62 438.9 582.26 438.9"
				style={{
					fill: '#5d6274',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				className="cloud2"
				d="M10224.4 12063.2c190.9 0 351.9-128.1 401.8-302.9h-803.59c49.91 174.8 210.89 302.9 401.79 302.9M9358.33 11760.3c-78.2 270.6-388.12 472.7-758.58 472.7-370.46 0-680.38-202.1-758.59-472.7h1517.17"
				style={{
					fill: '#5d6274',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M28359.3 9533.5c110.3 0 199.6 89.37 199.6 199.6 0-110.23 89.4-199.6 199.6-199.6-110.2 0-199.6-89.36-199.6-199.59 0 110.23-89.3 199.59-199.6 199.59M18987.6 11783.9c197.6 0 357.8 160.2 357.8 357.7 0-197.5 160.1-357.7 357.6-357.7-197.5 0-357.6-160.1-357.6-357.7 0 197.6-160.2 357.7-357.8 357.7M7232.52 8015.5c197.56 0 357.71 160.2 357.71 357.8 0-197.6 160.15-357.8 357.7-357.8-197.55 0-357.7-160.1-357.7-357.7 0 197.6-160.15 357.7-357.71 357.7M23616.3 5921.4c197.5 0 357.7 160.1 357.7 357.7 0-197.6 160.1-357.7 357.7-357.7-197.6 0-357.7-160.2-357.7-357.7 0 197.5-160.2 357.7-357.7 357.7M25951.5 11456.5c197.5 0 357.7 160.2 357.7 357.7 0-197.5 160.1-357.7 357.7-357.7-197.6 0-357.7-160.1-357.7-357.7 0 197.6-160.2 357.7-357.7 357.7"
				style={{
					fill: '#fff',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'twinkle'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M9701.56 3921.1c-737.36 0-1359.19-494.6-1551.98-1170h3103.92c-192.7 675.4-814.6 1170-1551.94 1170"
				style={{
					fill: '#ebccb9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M7885.32 3558.5c-508.85 0-937.98-341.3-1071.01-807.4h2142.02c-133.04 466.1-562.16 807.4-1071.01 807.4M12111.5 3916.8c-734.6 0-1354.2-492.7-1546.3-1165.7h3092.6c-192.1 673-811.7 1165.7-1546.3 1165.7"
				style={{
					fill: '#ebccb9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M10872.1 2876.7c194.8 0 359-130.7 410-309.1h-820c50.9 178.4 215.2 309.1 410 309.1M8873.69 3022.9c286.94 0 528.93-192.5 603.96-455.3H8269.74c75.03 262.8 317.01 455.3 603.95 455.3"
				style={{
					fill: '#ad6f5c',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M10748 2567.6c-92.6 320.4-459.6 559.8-898.25 559.8-438.68 0-805.67-239.4-898.28-559.8H10748"
				style={{
					fill: '#ad6f5c',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M8699.76 3899.9c34.34 17.5 76.41 3.9 93.97-30.4 7.86-15.4 9.43-32.3 5.73-47.9 67.04-47.6 130.25-99.4 189.17-153.1-20.05 62.7-45.1 157.6-51.05 254.1-18.41 5-34.75 17.3-44.11 35.6-17.56 34.3-3.95 76.4 30.38 94 34.34 17.5 76.41 3.9 93.97-30.4 17.56-34.4 3.95-76.4-30.38-94-3.96-2-8.03-3.6-12.14-4.8 9.41-144.4 64.53-288.8 73.32-311.1 126.46-123.4 230.13-251.4 305.55-354.2 135.52-184.8 211.82-330.9 212.58-332.4l-33.42-17.3c-.75 1.4-75.71 144.9-209.53 327.4-40.24 54.9-88.66 117-144.29 181.7-27.01 2.3-128.66 7.4-258.68-30.3 3.29-28.2-10.79-56.7-37.5-70.3-34.34-17.6-76.41-4-93.97 30.3-17.56 34.4-3.95 76.5 30.39 94 30.25 15.5 66.47 6.7 86.68-19 102.95 30.5 188.79 35.3 238.62 34.6-101.49 113.8-224.32 232.5-364 332.1-5.06-5.1-10.97-9.5-17.71-13-34.34-17.6-76.41-3.9-93.97 30.4-17.55 34.3-3.95 76.4 30.39 94"
				style={{
					fill: '#ad6f5c',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M9608.41 3524.1c-24.45 11.7-117.78 52.3-252.78 62.7-6.84-27.5-30.05-49.2-59.86-52.6-38.33-4.3-72.91 23.3-77.24 61.6-4.35 38.3 23.21 72.9 61.53 77.2 33.75 3.8 64.58-17.1 74.42-48.3 107.1-7.7 189.14-33.5 235.54-51.6-54.93 142.2-128.07 296.5-223.72 438.9-6.53-2.9-13.62-5-21.14-5.9-38.32-4.3-72.91 23.3-77.24 61.6-4.35 38.3 23.21 72.9 61.53 77.2 38.32 4.4 72.9-23.2 77.24-61.5 1.94-17.2-2.54-33.6-11.49-46.8 45.99-68.2 86.88-139 123.13-209.9 3.33 65.7 13.28 163.3 41.72 255.8-15.49 11.1-26.44 28.4-28.76 48.8-4.33 38.3 23.22 72.9 61.54 77.2 38.32 4.4 72.9-23.2 77.24-61.5 4.34-38.3-23.21-72.9-61.53-77.2-4.42-.5-8.77-.6-13.05-.3-42.08-138.5-41.34-293-40.95-316.9 74.86-160.1 126.82-316.4 161.18-439.2 61.74-220.7 81.71-384.3 81.9-385.9l-37.39-4.5c-.19 1.6-19.81 162.3-80.78 380.2-18.33 65.5-41.76 140.8-71.04 220.9"
				style={{
					fill: '#ad6f5c',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M25323.3 2823.5c-303.2 0-558.8-203.3-638.1-481h1276.1c-79.2 277.7-334.9 481-638 481"
				style={{
					fill: '#94b6c3',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24576.6 2674.5c-209.2 0-385.6-140.3-440.3-332h880.6c-54.7 191.7-231.1 332-440.3 332"
				style={{
					fill: '#94b6c3',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>

			<path
				d="M23818.1 7758.5h-3721v1978.04h3721V7758.5"
				style={{
					fill: '#f7f5f2',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23863.3 9531.81H20052v1014.69h3811.3V9531.81"
				style={{
					fill: '#786164',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M21968.3 9531.81h-21.3v1014.69h21.3V9531.81"
				style={{
					fill: '#80839e',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23239.8 9531.81h-21.3v1014.69h21.3V9531.81M23557.7 9531.81h-21.3v1014.69h21.3V9531.81"
				style={{
					fill: '#a7c3cc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22714.8 7758.5h-1514.3v1841.92l757.1 1046.68 757.2-1046.68V7758.5"
				style={{
					fill: '#f0eae5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m21957.6 10831.7-757.1-1046.74v-184.54l757.1 1046.68 757.2-1046.68v184.54l-757.2 1046.74"
				style={{
					fill: '#563a3d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22594.9 7758.5h-1274.6v176.669h1274.6V7758.5"
				style={{
					fill: '#555a6c',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22443.7 7890.1h-972.1v131.6h972.1v-131.6"
				style={{
					fill: '#555a6c',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22304.9 8021.7h-694.5v1124.34h694.5V8021.7"
				style={{
					fill: '#a76450',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23210.9 8843.69h-212.1v333.04h212.1v-333.04M23488 8843.69h-212.1v333.04h212.1v-333.04M23210.9 8449.4h-212.1v333.1h212.1v-333.1M23488 8449.4h-212.1v333.1h212.1v-333.1M20587.9 8843.69h-212.1v333.04h212.1v-333.04M20865 8843.69h-212.1v333.04h212.1v-333.04M20587.9 8449.4h-212.1v333.1h212.1v-333.1M20865 8449.4h-212.1v333.1h212.1v-333.1M21930.1 9695.1h-179.4v281.76h179.4V9695.1M22164.6 9695.1h-179.5v281.76h179.5V9695.1M21930.1 9361.53h-179.4v281.76h179.4v-281.76M22164.6 9361.53h-179.5v281.76h179.5v-281.76"
				style={{
					fill: '#a7c3cc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23593.5 9263.58c13.8 51.4 35.6 80.1 79.1 88.93 47.9 9.71 94.2-22.18 102.3-70.31l224.8-1342.6c3.5-21.1-10.3-41.3-31.4-45.6-21-4.2-41.6 8.9-46.6 29.8l-13.7 57.2c-259.8 897.46-350.2 1099.21-314.5 1282.58"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23357.6 10479.7c21.2 161.5 103.9 195.2 162.8 197.8 3.8 1.2 7.8 2.2 11.9 2.8 48.3 7.1 92.9-27.1 98.5-75.6l154.4-1352.46c2.4-21.33-12.5-40.75-33.7-43.91-7.1-1.05-14.1-.13-20.3 2.3-49.6 9.29-90.8 45.06-106.2 94.16-80.5 255.65-295 964.91-267.4 1174.91"
				style={{
					fill: '#d9ad93',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23048.8 9281.91c37.2 38.11 70.1 52.56 112.5 39.02 46.5-14.88 71.4-65.31 54.9-111.27l-458.8-1281.56c-7.2-20.2-29.2-31.1-49.6-24.5-20.5 6.5-32 28.1-26.2 48.7l16 56.6c211.1 910.14 230.6 1130.37 351.2 1273.01"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23138.5 10518.6c64.2 149.7 153 159.6 210.4 146.2 4 0 8.1-.1 12.2-.6 48.5-6.2 82.1-51.3 74.3-99.5L23217 9221.11c-3.4-21.18-23.1-35.83-44.4-33.11-7.1.91-13.5 3.68-18.9 7.73-45.1 22.37-75.1 67.99-76.6 119.45-8.1 267.88-22.1 1008.72 61.4 1203.42"
				style={{
					fill: '#d9ad93',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22717.9 7933.7c29.2 0 54.9 4.4 70.2 11 102.1-14.3 309.9-62.2 303.5-113.2-2.4-18.8-407.9-6.5-436.1-3.3-19.8 2.3-11.7 61.1-5.2 95.6 1.9 9.7 11.3 15.9 21 14 13.4-2.6 29.4-4.1 46.6-4.1M23965.2 7933.7c29.1 0 54.9 4.4 70.2 11 102.1-14.3 309.9-62.2 303.5-113.2-2.4-18.8-407.9-6.5-436.1-3.3-19.9 2.3-11.7 61.1-5.2 95.6 1.8 9.7 11.3 15.9 21 14 13.4-2.6 29.4-4.1 46.6-4.1"
				style={{
					fill: '#3b3e54',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23257.7 10729.6s88.6-668.8 330.3-1402.05c0 0-120.8-282.01 265.9-1200.55h145.1s-201.5 1168.32-209.5 1265.01c-8.1 96.69-137 1321.39-161.2 1385.89l-370.6-48.3"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23120.7 10745.7s-88.6-443.2-72.5-1418.15c0 0-217.6-233.66-346.5-1192.55l153.1-8s394.8 1079.69 402.9 1128.04c8 48.34 265.9 1522.86 265.9 1522.86l-402.9-32.2"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24776.3 11871.8c27.3-17.9 61.4-21.8 92.1-10.9 78.9 28.1 225.8 86.1 244.3 134.2 25.5 66.2-239.1 14.3-352-113.2l15.6-10.1"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23275.7 11890.5c-90.2 69.4-21.5 138.4-20.4 141.1 12.5 31.7 77.9 44.5 115.2 26.1l810.7-452.5c13.7-6 25.8-65.6 20.3-79.5-1.8-4.7-4.8-8.5-8.5-11.4-22.9-26.7-91-3.5-125.1 7.8-167.5 55.5-675 278.2-792.2 368.4"
				style={{
					fill: '#a0bec9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24844.9 11849.8c-157.6-112.6-536.2-305.6-655.4-335-99-24.4-112.3 36-113.7 38.3-15.7 27.1 3.7 82.6 37.3 98.6l690.1 280.9 41.7-82.8M23073.3 10886.9c-2.6 34.1-4.8 68.8-6.7 102.9-1.3 22.5-2.4 45.9-3.5 67.9-2.7 50.3-5.2 101.2-7.6 150.7-1.1 23.4-1.9 47.9-2.7 69.7-1.9 54.1-3.6 113.2-4.4 164.1-.3 22-1.7 45.7-1.3 60.6 2.1 97.1.2 193 8.1 284.9 4.6 53.8-.9 78.4 17.1 132.8 53.7 162.4 190.6 222.1 342.5 124.3 8.2-5.3 21.4-15.1 27.1-21.5 58.7-65.9 105.4-103.5 97.1-206.6-9.2-113.2 19-272.1 37.5-396.1 1.1-7.6 3.9-36.8 6-53.4 2.9-23.5 6.5-53.3 9.8-81.6 4.6-39.6 10.1-84 14.6-126.3 2.7-25.6 5.9-54.4 9.1-81.5 5.7-48 11.2-98 16.9-146.4 1.6-13.5 3.3-27.6 5.1-41.1 1.4-10.4 2.7-20.6 4.1-30.9 3.4-24.5 6.9-50.3 10.6-74.3 3.3-21 7.2-40 11.3-60.4 5.5-27.4 11.2-54.7 17.2-82.1-60.4-11.9-121.7-11.8-182-1-101.4 18.3-198.4 48.3-301.7 43.9-34.6-1.5-66.4-11.4-100-18.3-7.7 52-13.8 104.4-19.1 156.9-2 20.7-3.6 41.8-5.1 62.8"
				style={{
					fill: '#a0bec9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23556.2 12183.3s3.9 64.3-38.1 107.3-42.1-21.1-42.1-21.1l80.2-86.2M23159.3 12198.8c4.5-4.6 77.3-96.4 95.6-92.6 25.1 5.2-7.9 83.6-7.9 83.6l-87.7 9M23440.1 12433.9s8.6 60.2-23.3 91.2c-30.3 29.5-76 56.5-204.5-13.4-18.3-9.9-26.9-31.6-20.5-51.4l18.3-56.3 230 29.9"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23213.8 12250c38.1-77.5 75.4-138.9 137.9-157 21.9-6.3 47.8-9.5 75.6-4.7 17.4 3.1 35.5 9.2 53.8 19.6 47.9 27 64.6 62 62.7 104-2.2 48.1-28.8 105.4-60.7 170.4-59.7 121.6-150.4 153.9-224.8 117.4-74.3-36.5-104.2-128-44.5-249.7"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m23192.3 12270 140.6 22.1c3-19.2 28.7-202.8 25.5-272.7-3.9-21.7-38.6-33.6-77.4-26.5-35 6.3-61.2 25.8-63.3 45.4h-.1c1.8 42-14.8 164.5-25.3 231.7"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23165.7 12191.2s37.2 1.2 55.6 40c24.1 51.1 30.6 147 26.8 188.5-6.8 72.9-32.4 84.5-32.4 84.5s-126.4-52.9-139.9-105.2c-20.2-78.3 89.9-207.8 89.9-207.8"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m23228.5 12330.3 87.1-177.6c9.2-18.8 28.7-30.2 49.5-29.1l24 1.3c14.7.8 25 14.9 21.4 29.1l-10 39.1c-2.3 8.8 1.6 17.9 9.3 22.5l77.3 45.6c8.3 4.9 18.9 3.3 25.3-3.8l26.9-29.5c26.6-29 21.2-74.9-11.4-97l-45.2-30.7c-9.6-6.6-20.7-10.7-32.3-12-.8-.1-1.7-.3-2.6-.3l-1.6-.1-18.5-1-60.4-3.2c-36.9-1.9-71.4 18.3-87.6 51.5l-87.1 177.6 35.9 17.6"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23160.8 12220.1c12.8-26.4 55.5-47.5 74.6-38.2 19.2 9.3 13.5 33 .7 59.4s-40.3 43.6-59.4 34.4c-19.2-9.3-28.7-29.2-15.9-55.6"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m23226.9 12443.4 78.7 37.9c26.4 12.6 56.5 15.4 84.7 7.7l38.4-10.4-72.1 55.9-74.8-6.7-77.5-44.6 22.6-39.8"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23252.6 12395.3s273.5 163.1 237.2 201.6c-36.3 38.4-143.9-13.9-143.9-13.9l-93.3-187.7"
				style={{
					fill: '#9597a3',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m23378.6 12584.6-248-372.5s-100.2 115.5-98 190.3c2.1 74.7 135 171.2 265.6 209.5 72.9 21.4 80.4-27.3 80.4-27.3"
				style={{
					fill: '#adaeb7',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23211.4 11830.7c63.9 94.1-22.9 138.2-24.7 140.4-21.9 26.2-88 17.9-117.6-11.2l-628.7-683.2c-11.1-10 5.1-28.8 14.7-40.3 3.2-3.9 7.3-6.6 11.7-8.2 30.1-18.2 76.4-13.5 107.2 4.9 160.7 96 554.3 475.3 637.4 597.6"
				style={{
					fill: '#a0bec9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23570.1 10639.4c-25.8-2.3-33.1-19.4-59-18.7 14.4 95.7 34.7 196 57.5 298.4l53.6-27.8c-22.2-79.6-40.4-163-52.1-251.9"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23517.7 10682.3s-45.9-40.2-34.5-50c11.4-9.9 185.2-137.5 191.6-130.4 22 24.3-105.9 149-122 156.1-16.1 7.2-28.6 30.2-35.1 24.3"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23618.9 10606.7c-24.3 3.7-58.5 18.7-92.8 42.3-10.9 7.6-21 15.4-30.1 23.4-14.2-15.8-29.2-35.3-22.3-41.4 12-10.9 198.4-149.2 206.4-140.1 15.7 18-22.6 72-61.2 115.8"
				style={{
					fill: '#848593',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22991.2 11307.3s-139.8-198.1-13.9-304.4c125.9-106.3 526.3-28.6 549.6-10.7 0 0-55.5-29.6-18.9-261.2 0 0 58.3-27.2 77.4-28.8 0 0 73.5 286.3 68.9 322.5-3.1 23.8-15.5 124.2-457.4 147.7l-205.7 134.9"
				style={{
					fill: '#9597a3',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23410.8 10572.2c-25.6 3.7-36.7-11.2-61.7-4.5 36.4 89.7 79.5 182.6 125.6 276.8l45.6-39.6c-40.2-72.1-77.3-149-109.5-232.7"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23369.9 10626.1s-54-28.3-45.2-40.5c8.7-12.3 147.9-176.9 155.8-171.5 27.1 18.4-68.2 169.6-82.2 180.3-13.9 10.6-20.7 36-28.4 31.7"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23450.7 10529c-22.8 9.2-52.6 31.8-80.4 62.8-8.9 9.9-16.8 19.9-23.8 29.8-17.6-12-36.6-27.5-31.4-35.1 9.2-13.4 158.1-191.4 168-184.4 19.5 13.8-5.2 75.3-32.4 126.9"
				style={{
					fill: '#848593',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22999.3 11341s-178.3-164.4-77.6-294.8c100.8-130.3 508.6-138.4 535.1-125.9 0 0-60.5-17.2-73.3-251.3 0 0 51.2-38.9 69.6-44.5 0 0 134.6 276.9 135.1 300.9.5 30 10.9 124.6-416.2 240.5l-172.7 175.1"
				style={{
					fill: '#9597a3',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23053.2 11694.5c-20 51.5 17 72.8 18.4 73.4 23.1 10.2 52.4-3.8 61-21.3l145-265.1c3-4.3 9.4-37.6-10-44.6-16-7.6-35-5.4-45 2.5-52.1 41.2-149.6 204.2-169.4 255.1"
				style={{
					fill: '#fccb7d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22976.3 11999.2s-13.1-77.2-64.9-82.2c-51.9-4.9-94.8 51.3-140.2 9.7-45.4-41.5-55.7 1.6-109.2-22.1-82.4-36.4-131.4-196.6-16.6-281.3 119.1-87.8 214.5-43.1 273.5 16.2 58.9 59.3 75.6 160.4 90.2 237.2 14.5 76.7-32.8 122.5-32.8 122.5"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22877 11678.3c57.8 199.1 160.5 144.7 216 122.6 32.1-40.3 60.4-50.9 58.6-159.1-2.9-175.6 12.8-294.9 64.6-472.5-87.8-9.9-157.2-72.5-244-64.1-47.7 4.7-73.6-1.3-107.6 24.6-51.4 139.9-10.7 468.6 12.4 548.5"
				style={{
					fill: '#fccb7d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22953.7 11850.2c-64.2 9.2-106.8 83.6-95.1 166.2 11.8 82.6 73.4 142.2 137.7 133.1 64.2-9.2 106.8-83.6 95.1-166.2-11.8-82.6-73.4-142.2-137.7-133.1"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22963.3 11944.9c34.8-82.9 120.7-125.9 171.4-104.6 50.7 21.2 46.9 98.6 12.1 181.5s-93.5 107.9-144.2 86.6c-50.7-21.2-74-80.6-39.3-163.5"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m22972.2 11956.9 94.4 3.4c.4-12.9 2.9-135.8-4.7-181.6-4.3-13.9-28.1-19-53.1-11.3-22.5 6.9-38.2 21.8-38.1 34.9h-.1c4.6 27.5 3.3 109.4 1.6 154.6"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22939.1 12092.3s94.2-31.8 154.4-38.7c61.3-7 69.8-78.8 69.8-78.8s9.6 106.3-33.7 148.6c-43.3 42.3-154.7 48-190.5-31.1"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22996.2 12094.3s21.3-73.6-7.5-107.2c-28.8-33.5-30.4-55.6-30.4-55.6l-27.9 36.7-29.8 110.7 95.6 15.4"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22937.9 11906.8c8.1-19.3 37.6-36 51.6-30.1 14 5.9 10.9 23 2.8 42.3-8.1 19.3-27 32.6-41 26.7-13.9-5.9-21.5-19.6-13.4-38.9M23450 11223.8c-3.6-20.7 2.8-41.9 17.4-57.2 28.1-29.6 74.9-74.8 97.4-73.9 33.4 1.3-38.6 106.1-114.8 131.1"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23491.1 11225.4c-43.8 80.4-124 193.3-169.7 235-37.9 34.5-68.8 1.5-69.9 1.1-12.9-5.2-36.3-11.1-25.2-25.5l216.4-243.8 48.4 33.2M22953.1 11769.9c41.8-36.1 19.1-72.3 18.2-73.5-15.7-19.8-48.1-21.2-63.9-9.7l-252.4 166.1c-4.7 2.3-25.9 28.7-12.1 44 10.6 14.2 28.4 21.2 40.9 18.9 65.3-11.9 227.9-110.2 269.3-145.8"
				style={{
					fill: '#fccb7d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22628.1 12184.3c-20.5 4.8-37.5 19-45.9 38.3-16.4 37.5-39.7 98.2-30.2 118.5 14.3 30.3 82.8-76.8 76.1-156.8"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22642.6 12216.6c34.6-84.8 71.3-218.3 74.6-280.1 2.8-51.2-42.3-54.2-43.4-54.8-12.1-6.8-31.5-21.1-35.6-3.4l-51.8 321.8 56.2 16.5"
				style={{
					fill: '#fccb7d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23138.1 10880.1c12.8 30 39 52.2 70.7 60.1 81.2 20.3 235.6 53.4 277.7 23.6 57.9-41-191.2-144.4-355.8-100.8l7.4 17.1"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M23180.2 10933.3c-157 113.5-534.5 308.5-653.6 338.6-98.9 24.9-112.5-35.5-113.9-37.8-15.8-26.9 3.3-82.6 36.7-98.7l688.6-284.7 42.2 82.6"
				style={{
					fill: '#a0bec9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24425.5 7956.6s28.3-96.2 11.3-101.8c-17-5.7-413-22.7-441.3-5.7-28.2 17 56.6 45.3 56.6 45.3s186.7 50.9 294.2 62.2c0 0 79.2 5.7 79.2 0"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24480.3 9263.44c-22.6 45.26-48.2 67.89-90.5 67.89-46.4 0-83.5-38.45-82-84.81l44.2-1292.92c.7-20.4 17.4-36.6 37.8-36.6s37.1 16.2 37.8 36.6l1.9 55.8c72.6 884.98 118.7 1089.98 50.8 1254.04"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24620.2 10407.4c-32.3 151.4-113.2 177.1-169.2 175.2-3.7.8-7.5 1.4-11.5 1.7-46.3 3.1-86-32.7-87.6-79l-44.6-1292.97c-.7-20.39 14.9-37.67 35.2-39.07 6.8-.47 13.3.93 19.1 3.71 46.2 12.52 82.6 49.51 93.5 97.2 57 248.25 207 936.33 165.1 1133.23"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24493.5 10316.7c5.1 154.7 80.3 194.3 135.7 202.2 3.5 1.4 7.2 2.7 11 3.7 45 11.3 90.4-17 100.1-62.4l271.3-1264.92c4.3-19.95-8-39.69-27.8-44.66-6.6-1.65-13.3-1.41-19.4.32-47.7 4.19-90 34.21-109.2 79.23-99.8 234.35-368.3 885.33-361.7 1086.53M25222.9 7946.2s-26.2-96.7-9.1-102c17.1-5.3 413.4-13.5 441.3 4.1 27.9 17.6-57.6 44-57.6 44s-187.8 46.8-295.5 55.7c0 0-79.3 3.9-79.1-1.8"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24189.7 7938c41-18 109.2-29.8 186.3-29.8 24.7 0 48.4 1.2 70.7 3.5 5.1-35 7.4-75.7-9.6-77.6-29.9-3.5-460.4-16.6-463 3.4-5 39.4 110.6 77.1 215.6 100.5"
				style={{
					fill: '#44495e',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24827.3 9208.27c10.1 51.84 29 81.31 69.9 91.8 45 11.52 91-18.52 101.6-66.25l295.7-1331.32c4.7-21-7.3-41.7-27-46.7-19.8-5.1-40.2 7.3-46.2 27.9l-16.5 56.6c-302 885.7-400.3 1083.57-377.5 1267.97"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M25459 7932.9c-40.6-18.9-108.5-32.2-185.6-33.9-24.7-.6-48.5.1-70.7 1.8-4.4-35-5.8-75.8 11.2-77.3 30-2.8 460.8-6.4 462.8 13.6 4.2 39.6-112.2 74.7-217.7 95.8"
				style={{
					fill: '#44495e',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24928.1 10523.2s158-1138.49 209.7-1498.29c0 0-354.3-147.29-670.4-94.35l-95.7 30.91-159.5 14.47s41.9 342.53 41.9 386.04c0 43.52-3.2 1189.32 156.5 1161.22h517.5"
				style={{
					fill: '#353b51',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24633.2 12419.5c206.8 64.3 512.6-111.9 486.3-351.4-2.4-22.5-7.4-45.5-3.3-67.3 6.5-34.4 33.9-59 61.7-78.2 62.5-43 135.6-72 187.6-127.6 83.3-89.1 92.1-245.4 15.4-349.8-70.8-96.6-294.4-181.1-404.8-156.9-110.3 24.1-201 104.8-257.7 203.6-14.1 24.7-26.7 51-46.6 70.8-37 36.7-92.7 45.5-137.5 71.8-41.8 24.5-31.3 124.3-46.4 171.8-19.6 61.4 40.5 115.2 27.7 178.8-14.9 74.6-59 141.6-57.5 218.7 1.8 98.1 82.6 187 175.1 215.7"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24953.6 10398.1c14.7-2.2-12.1 493-32.5 544.9 19.5 216.4 26 629.6-11.6 809.5-47.2 225.9-85.6 303.2-294 252.6-65.6-15.9-120-178.4-145.3-298.8-25.4-120.4-53.5-130.7-1.8-348.2 18.4-77.3-65.3-572.2-108.2-710.3-12.3-39.7-17.7-173.8-41.5-214.9 25.4-18.7 57.8-40.4 85.6-47.5 190.8-48.8 352.7 42.1 549.3 12.7"
				style={{
					fill: '#c19b85',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24705.1 11853.4c60.5 87.7-20.6 129.6-22.3 131.7-20.3 24.6-82.3 17.3-110.2-9.8l-556.4-589.6c-10.5-9.3 4.6-27 13.5-37.8 3-3.7 6.8-6.3 10.9-7.8 28.1-17.2 34.7-59.5 63.7-42.5 151.1 88.9 522.2 441.7 600.8 555.8"
				style={{
					fill: '#c19b85',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24719.7 11837c-51.5 82.9 28 125.1 29.8 127.2 20.8 24.2 79 18.6 103.7-6.8l519.7-598.2c9.4-8.7-6.1-26.1-15.3-36.8-3-3.5-6.8-6.1-10.8-7.7-27.7-17.2-68.5-14.2-94.9 1.5-137.1 82-465.2 412.9-532.2 520.8"
				style={{
					fill: '#c19b85',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24741.6 12077s144.5 55.4 153.1 202c11.5 196.8-189.3 289.3-295.8 222.3-98.1-61.6-79.3-146.2-67.2-166.9 12.1-20.7 209.9-257.4 209.9-257.4"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m24784.6 12263.2-157.7 11.1c-1.6-21.6-12.6-227.2-2.5-304.2 6.4-23.7 46-33.6 88.3-22.1 38 10.3 65.2 34.4 65.6 56.3l.2.1c-6 46.2.8 183.3 6.1 258.8"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24773.4 12240.2c-23.9-124.5-130-208.7-206-194.1-76.1 14.6-93.3 122.5-69.4 247 23.9 124.4 97.7 175.9 173.7 161.3 76.1-14.6 125.6-89.7 101.7-214.2"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24579.5 12467.4s31.8-166.7 186.6-222.8c79.8-29 105.3 96.8 105.3 96.8l-79.1 119s-64.4 50.5-113.2 45.1c-4.2-.5-99.6-38.1-99.6-38.1"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24523.3 12371.6s138.6 50.8 159 99.2c20.4 48.5-50.9 42.2-50.9 42.2s-91.9-34.2-108.1-141.4M24744.6 12479.3s-63.2 48.4-21 107.4c42.1 59 115.6 37.1 132.7-8.4 19-50.6-6.3-82.2-27.4-96.9-21-14.8-59-16.9-84.3-2.1"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24834.8 12194.5c-12.4-28.9-56.9-53.7-77.9-44.8-21 9-16.2 34.7-3.9 63.6 12.4 29 41 48.8 61.9 39.9 21-9 32.2-29.7 19.9-58.7"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24295.2 10642.2c25.7-3.4 32.3-20.7 58.2-21.1-10.6 96.2-26.7 197.3-45.4 300.6l-54.7-25.8c19-80.3 33.8-164.4 41.9-253.7"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24349.3 10682.9s44.2-41.9 32.4-51.3c-11.7-9.4-190.5-129.9-196.7-122.5-20.9 25 111.9 144.6 128.3 151 16.3 6.5 29.7 29 36 22.8"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24245.1 10611.5c24.5 2.7 59.3 16.3 94.4 38.5 11.3 7.2 21.7 14.6 31.1 22.2 13.6-16.3 27.7-36.4 20.7-42.3-12.5-10.4-204.4-141.1-212-131.7-14.9 18.7 25.5 71.1 65.8 113.3"
				style={{
					fill: '#fccb7d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24900.6 11286.3s131.7-203.7 1.6-304.8c-130.1-101.1-527-7.3-549.6 11.5 0 0 54.3-31.8 8.3-261.7 0 0-59.3-24.9-78.5-25.8 0 0-61.8 289.1-55.7 325.1 4 23.6 20.4 123.4 462.9 129.2l211 126.5"
				style={{
					fill: '#54576a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24451.7 10568.6c25.7 2.7 36.2-12.6 61.5-6.9-32.8 91.1-72.1 185.6-114.4 281.6l-47.1-37.7c37.2-73.7 71.2-152 100-237"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24494.7 10620.8s52.8-30.4 43.6-42.3c-9.3-11.9-155-170.8-162.7-165.1-26.3 19.5 75 166.8 89.4 176.9 14.4 10.1 22.2 35.1 29.7 30.5"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24410.1 10527.1c23.2 8.3 53.9 29.7 82.8 59.5 9.3 9.5 17.7 19.2 25.1 28.8 17-12.7 35.4-28.9 29.9-36.3-9.7-13-165.7-184.9-175.3-177.5-18.9 14.6 8.2 75 37.5 125.5"
				style={{
					fill: '#fccb7d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24893.9 11320.2s171.5-171.4 65.6-297.6c-106-126.2-513.7-117.9-539.8-104.2 0 0 59.8-19.7 63.2-254.2 0 0-52.8-36.7-71.4-41.6 0 0-123.3 282.1-122.8 306.1.7 30-5.9 125 425.5 223.5l179.7 168"
				style={{
					fill: '#54576a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24854.2 11675.7c22.1 50.5-14.1 73.4-15.4 74-22.7 11.1-52.5-1.7-61.8-18.8l-155.6-259.1c-3.2-4.1-10.9-37.2 8.2-44.9 15.7-8.2 34.7-6.8 45 .6 53.8 39.1 157.8 198.1 179.6 248.2"
				style={{
					fill: '#a0bec9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M25029.6 11652.3c-49.7 201.3-154.5 151-210.9 131.2-33.7-39-62.3-48.4-64.9-156.5-4.2-175.7-24.6-294.2-83.6-469.6 87.3-13.4 154.1-78.8 241.2-73.9 47.9 2.8 73.5-4.2 108.6 20.3 56.9 137.7 29.5 467.8 9.6 548.5"
				style={{
					fill: '#a0bec9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24438.8 11221.3c2.7-20.9-4.6-41.8-19.7-56.5-29.3-28.4-77.8-71.7-100.3-69.9-33.3 2.7 42.8 104.5 120 126.4"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24397.8 11224.5c47 78.6 131.7 188.2 179 228 39.3 32.9 68.8-1.2 69.9-1.7 12.7-5.7 35.8-12.6 24.1-26.5l-226-234.9-47 35.1M24957.3 11746.9c-43.2-34.3-22-71.4-21.1-72.7 14.8-20.4 47.2-23.1 63.4-12.3l258.9 155.8c4.8 2.2 27.1 27.7 13.8 43.6-10 14.5-27.4 22.2-40.1 20.5-65.7-9.3-232.2-101-274.9-134.9"
				style={{
					fill: '#a0bec9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M25298.7 12147.9c20.7 4 38.3 17.5 47.5 36.4 17.8 36.8 43.6 96.5 34.8 117.2-13 30.8-85.7-73.4-82.3-153.6"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M25285.5 12180.7c-38-83.3-80-215.3-85.8-276.8-4.8-51 40.1-55.9 41.1-56.5 11.9-7.3 30.7-22.4 35.5-4.8l64.8 319.4-55.6 18.7"
				style={{
					fill: '#a0bec9',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24863.4 11787.3c61.7-14.5 126.9 38.1 145.5 117.4 18.6 79.4-16.3 155.5-78 170s-126.8-38.1-145.5-117.4c-18.6-79.4 16.3-155.5 78-170"
				style={{
					fill: '#5b6072',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24935.3 11893.5c-40.5-77.9-127.6-112.8-175.2-88-47.6 24.7-37.7 99.8 2.8 177.6 40.5 77.9 99.7 97.5 147.3 72.7 47.6-24.7 65.6-84.4 25.1-162.3"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m24918.7 11924.4-92.2-.9c.1-12.6 3.3-132.6 12.7-176.9 4.8-13.5 28.3-17.3 52.3-8.7 21.7 7.8 36.3 23 35.6 35.8h.1c-5.7 26.6-8.1 106.6-8.5 150.7"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24931.1 12048.5s-1-8.6-.8-69.4c.1-60.7-39.2-102.2-25.3-108.5 14-6.3 37.5-1.9 56.8 24.5 19.3 26.3 24.5 159.9-30.7 153.4"
				style={{
					fill: '#5b6072',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24957 11854.4c-9.5-18.2-39.5-32-52.6-25.2-13.2 6.9-8.8 23.3.6 41.4 9.4 18.1 28.9 29.6 42 22.7 13.2-6.8 19.4-20.8 10-38.9"
				style={{
					fill: '#f5d1bc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24974.8 11977.5s-71.4 1.7-120.9 41.2c-36.2 28.8-102.2-35.2-103.9-22.5-1.7 12.6 51.9 93.5 117.6 91.7 64.7-1.7 103.1-50.3 107.2-110.4"
				style={{
					fill: '#5b6072',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24769.6 10885.4c-9.9-4.8-20.7-8.1-31.9-9.4-77.9-9.2-225.3-21.5-260.9 11.2-46.5 42.7 171.7 104.8 320.2 59.1l-27.4-60.9"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24768.4 10878.7c166.7 71.8 504.8 281.9 586.1 363.3 67.5 67.6 25.5 107.5 24.3 109.7-14.1 25.7-68 37.1-97.1 17.9l-559.4-417.4 46.1-73.5"
				style={{
					fill: '#c19b85',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24205.5 10960.7c28.6 10.7 60.6 7.4 86.5-9 66.3-41.9 188.6-125.1 195.7-172.9 9.6-65.7-221.6 36.2-298.5 175.8l16.3 6.1"
				style={{
					fill: '#a45f4a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M24268.2 10963.4c-53.1 173.6-53 315.7-125 405.4-59.7 74.5-104 37.2-106.3 36.2-27.1-11.1-44.3-63.5-28.4-94.5l181.5-384.9 78.2 37.8"
				style={{
					fill: '#c19b85',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M22257.7 12006.4c-66.6 93.1-177.9 125.9-267.4 126-211.2 0-397.8-254.2-397.8-254.2s-186.5 254.2-397.7 254.2c-136.2-.1-323.1-76.2-325.7-325-1.5-141.1 106.6-220.7 228.9-265.3 98.6-36 206.4-49.3 273.7-53.9 150.6-10.2 220.8-203.4 220.8-203.4s70.3 193.2 220.9 203.4c150.7 10.2 505.3 64.3 502.6 319.2-.9 85.4-23.5 150.4-58.3 199M24109.5 13848.8c-67.4 94.2-180.2 127.5-270.8 127.5-213.8.1-402.7-257.3-402.7-257.3s-188.9 257.4-402.7 257.3c-138 0-327.2-77.1-329.8-329-1.6-142.9 107.9-223.5 231.7-268.7 99.8-36.4 209-49.9 277.1-54.5 152.5-10.3 223.7-206 223.7-206s71.1 195.7 223.7 206c152.5 10.3 511.5 65.1 508.8 323.2-.9 86.4-23.8 152.3-59 201.5"
				style={{
					fill: '#e3b69d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'hearts'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14723.824 7816.646h-1080.5v695.3h1080.5v-695.3"
				style={{
					fill: '#b88272',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14727.6 7836.4h-375.5v695.3h375.5v-695.3"
				style={{
					fill: '#ad6f5c',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14721.5 8332.2H13641v181.2h1080.5v-181.2"
				style={{
					fill: '#a86652',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14766.4 8379h-1170.3v152.7h1170.3V8379"
				style={{
					fill: '#b88272',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11591.9 9103.44h1406.3v234.53h-1406.3v-234.53"
				style={{
					fill: '#786164',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11507.2 7836.5h50.1l159.7 1501.47h-107.5l-102.3-1501.47M12025.5 7836.5h50.2l159.7 1501.47h-107.5l-102.4-1501.47M12952.3 7836.5h-50.1l-159.7 1501.47h107.5l102.3-1501.47"
				style={{
					fill: '#786164',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11591.9 9264.65h897l-341.5 1377.05h-897l341.5-1377.05"
				style={{
					fill: '#786164',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M12263 10953.7c10.2 32.9 4.5 68.6-15.5 96.6-51.2 71.9-152.4 204.3-206.5 209.3-74.5 6.8 54.4-246.8 216.2-324.6l5.8 18.7"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M12266.9 11019.9c101.4-177.5 263.5-595.3 281.5-723.6 15.1-106.4-49.8-113.9-52.3-115.1-30.1-13.6-86.3 12.7-99.5 49.6l-221 754.1 91.3 35"
				style={{
					fill: '#fff',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m12208.8 11122.9-174.7-145.7c-4.9-4-12.1-3.4-16.2 1.5l-267.3 320.6c-4 4.9-3.4 12.1 1.5 16.2l174.7 145.7c4.9 4 12.1 3.4 16.2-1.5l267.3-320.6c4.1-4.9 3.4-12.2-1.5-16.2"
				style={{
					fill: '#383e56',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m11931.3 11441.3-160.5-133.8c-1.7-1.4-1.9-4-.5-5.7l89.6-107.4 60.5-72.6 41.9-50.3 47.3-56.7c1.5-1.7 4-2 5.7-.6l160.5 133.8c1.7 1.5 1.9 4 .5 5.7l-89.2 107-60.5 72.6-41.3 49.6-48.3 57.9c-1.4 1.7-4 1.9-5.7.5M12150.9 11074.6l-58.9-49.1-4.4 10c-2.3 5.3-.8 11.4 3.6 15l35.2 29.4c4.4 3.7 10.7 4 15.4.8l9.1-6.1"
				style={{
					fill: '#6e7282',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				className={'phoneperson'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M13273.6 9370.67c37.8 41.51 72 57.94 117.1 45.19 49.6-14 77.6-66.28 62-115.31l-437.4-1367.45c-6.9-21.6-29.7-33.8-51.5-27.6-21.7 6.1-34.7 28.4-29.3 50.4l14.8 60.3c189.6 966.92 202.2 1199.77 324.3 1354.47"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M12016.1 9226.1c-163.6 52.69-182.8 144.94-174.3 206.5-.5 4.24-.7 8.53-.6 12.92 1.7 51.46 45.8 91.24 97.1 87.77l1432.5-96.86c22.5-1.53 39.9-20.69 39.1-43.31-.2-7.57-2.5-14.59-6.2-20.62-19.1-49.62-64-85.59-117.9-92.29-280.5-34.87-1057.1-122.62-1269.7-54.11M12912.3 8996.28c-7 55.71 2.7 92.4 41.7 118.45 42.8 28.59 100.8 16.02 127.9-27.74l756.4-1220.29c11.9-19.3 6.4-44.5-12.4-57.1-18.8-12.6-44.2-8-57.5 10.4l-36.2 50.4c-612.4 771.9-781.4 932.6-819.9 1125.88"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11653.3 9258.44c-145.7 91-141.8 185.14-118.6 242.78.6 4.22 1.4 8.45 2.6 12.67 14.3 49.47 66.7 77.32 115.6 61.42l1365.5-443.49c21.5-7 33.7-29.8 27.4-51.56-2.1-7.27-6-13.52-11.1-18.46-30.6-43.47-82.9-67.39-136.8-60.74-280.5 34.63-1055 139.04-1244.6 257.38"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M13762.4 7903.3c30.8 0 58 4.6 74.1 11.6 107.7-15 326.9-65.6 320.1-119.4-2.5-19.8-430.2-6.8-459.9-3.4-21 2.4-12.4 64.4-5.5 100.8 1.9 10.2 11.9 16.8 22.2 14.8 14.1-2.8 30.9-4.4 49-4.4M12975.7 7944.3c30.8 0 57.9 4.5 74.1 11.5 107.6-15 326.9-65.5 320-119.4-2.5-19.8-430.2-6.8-459.9-3.4-20.9 2.4-12.4 64.4-5.5 100.8 2 10.3 11.9 16.8 22.2 14.8 14.1-2.7 30.9-4.3 49.1-4.3"
				style={{
					fill: '#3b3e54',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11508 9562.1s-72.1-273.19 226.6-361.44c298.6-88.25 1162.1-215.26 1162.1-215.26s-33.9-134.06 691-969.9l139.2 49.5s-618.4 1041.09-639.8 1065.07c-61.8 69.3-1122.5 403.43-1122.5 403.43s-298.7 59.5-456.6 28.6"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m12953.2 8130.6 116.8-26.6s429 1186.92 405 1248.71c-24 61.79-20.2 108.44-367.3 116.71-347.1 8.27-1198 101.58-1198 101.58l106.4-344.9s921.5-34.07 1179 20.19c0 0-141-423.59-241.9-1115.69"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11666.9 10825.3c-71.3 96.4 18.3 146.6 20.2 149 21.9 28.5 91.9 22.6 124.4-6.8l691.4-693.3c12.2-10.1 7.3-74-2.3-86.6-3.2-4.2-7.4-7.2-11.9-9.1-31-20.4-93.4 22.8-124.7 44.1-153.9 104.7-604.3 477.3-697.1 602.7"
				style={{
					fill: '#fff',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11465.5 9759.92c-3.9 35.86-7.5 72.4-10.8 108.25-2.2 23.69-4.1 48.29-6.1 71.49-4.7 52.86-9.2 106.44-13.4 158.44-2.1 24.7-3.8 50.5-5.4 73.5-4 56.9-7.9 119.1-10.5 172.7-1.2 23.2-3.5 48.2-3.6 63.9-1.3 102.5-6.8 203.4-1.8 300.7 3 56.8-3.7 82.5 13.3 140.5 50.8 173.2 192.9 241 356.6 143.4 8.8-5.3 23.1-15.2 29.3-21.7 64.2-67.4 114.9-105.3 109.8-214.2-5.6-119.7 29.8-286.2 53.7-416.3 1.5-7.9 5.6-38.6 8.3-56 3.9-24.7 8.8-55.9 13.3-85.6 6.3-41.6 13.7-88.3 20-132.7 3.8-26.8 8.2-57.1 12.5-85.55 7.7-50.35 15.3-102.89 23.1-153.75 2.1-14.17 4.4-28.97 6.9-43.07 1.8-10.91 3.6-21.64 5.4-32.47 4.4-25.68 9-52.77 13.9-77.95 4.2-22.01 9-41.86 14-63.24 6.8-28.72 13.8-57.23 21.1-85.91-63.3-14.75-127.9-16.87-191.8-7.57-107.6 15.63-210.8 43.67-319.6 35.34-36.4-2.79-69.6-14.44-104.7-22.88-10 54.53-18.4 109.49-25.8 164.65-2.9 21.82-5.3 43.99-7.7 66.02"
				style={{
					fill: '#fff',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11927.8 11143.9s1.8 67.9-44 111.7-43.6-23.7-43.6-23.7l87.6-88M11508.8 11145.9c5-4.7 85.1-98.8 104.2-94.1 26.2 6.3-11.3 87.8-11.3 87.8l-92.9 6.3M11796.4 11403.9s6.9 63.7-27.9 95.3c-32.9 29.9-82.2 56.7-215-21.5-19-11.2-27.3-34.3-19.8-55l21.3-58.6 241.4 39.8"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11564.5 11201.8c42.9-80.3 84.4-143.6 151-160.5 23.3-5.9 50.7-8.2 79.8-2.2 18.2 3.8 37.1 10.9 56.1 22.5 49.5 30.3 65.8 67.8 62.3 112-4.1 50.6-34.2 110-70.1 177.3-67.4 126.2-164.2 156.9-241.2 115.8-77.1-41.2-105.3-138.8-37.9-264.9"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m11541 11222.2 147.5 28.4c3.9-20.2 37.5-212.8 36.7-286.6-3.3-23.1-39.5-36.8-80.7-30.8-37 5.4-65.3 25-68.3 45.6l-.1.1c.4 44.2-21.5 172.8-35.1 243.3"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11515.8 11138.1s39.3 2.6 57.2 44.2c23.6 54.7 27 156.1 21.5 199.6-9.8 76.7-37.2 88-37.2 88s-131.3-60.3-143.6-116c-18.6-83.3 102.1-215.8 102.1-215.8"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m11577.1 11287 98.2-184.1c10.4-19.4 31.3-30.7 53.2-28.8l25.2 2.2c15.5 1.3 25.9 16.6 21.5 31.5l-11.9 40.8c-2.7 9.2 1 18.9 9 24.1l79.9 50.8c8.5 5.4 19.7 4.1 26.8-3.1l29.4-30.1c29-29.6 25-78.2-8.5-102.7l-46.5-34c-10-7.3-21.5-12-33.7-13.8-.9-.2-1.8-.3-2.7-.4l-1.7-.1h-.1l-19.4-1.7-63.6-5.6c-38.8-3.4-75.8 16.7-94.2 51.1l-98.1 184 37.2 19.9"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11509.7 11168.4c14.5-27.4 60.2-48.1 80-37.6 19.8 10.5 13.1 35.3-1.4 62.7-14.5 27.4-44.1 44.5-63.9 34-19.8-10.4-29.2-31.7-14.7-59.1"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m11571.3 11406.2 81.6 42.7c27.4 14.3 59 18.3 89 11.2l40.9-9.6-78.1 56.4-78.6-9.8-80-49.8 25.2-41.1"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11683.9 10863.2c84.3-295.8-8.8-572.2 110.4-872.05 42.9-28.26 88-53.53 132.5-79.31 19.9 50.23 39.1 99.86 53.7 151.96-158.9 279.9-122.9 539.7-239.2 813.6-19.2-4.5-38.3-9.4-57.4-14.2"
				style={{
					fill: '#f4c994',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11586.6 10764.8c70.6 96.9-19.4 146.4-21.3 148.8-22.2 28.3-92.1 21.8-124.4-7.8l-685.8-698.9c-12.2-10.1 4.3-30.5 14.1-43 3.2-4.1 7.4-7.2 12-9 31.1-20.2 80-16.8 113.2 1.6 172.6 95.7 600.4 482.1 692.2 608.3"
				style={{
					fill: '#fff',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11571.7 10100.9c11.6 32.4 37.6 57.5 70.4 68 84.2 26.7 244.5 71.9 290.8 43.3 63.7-39.2-191.6-164.7-367.7-129.8l6.5 18.5"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M11593.9 10157.5c-199 46.5-645.8 82.4-773.9 63.1-106.2-16-94.9-80.3-95.3-83.1-4.5-32.7 36.8-79 75.9-81.1l785.9 3.6 7.4 97.5"
				style={{
					fill: '#fff',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M13977.5 10039.2h-1537v95h1537v-95"
				style={{
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
					fill: '#9b9b9b',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M13977.5 10124.9h-1286.1l203.8 861.8h1286.1l-203.8-861.8"
				style={{
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
					fill: '#a8a8a8',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14627.7 9932.8H10544v113.5h4083.7v-113.5"
				style={{
					fill: '#5b6072',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14600.6 7836.5h-20.8l-316.3 2141.51h134.4l202.7-2141.51M10544 7836.5h20.8l316.3 2141.51h-134.4L10544 7836.5"
				style={{
					fill: '#5b6072',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m18000 7262.4-433-4549.3h866z"
				style={{
					fill: '#3b3e54',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M19379.1 2879.1h-2758.2V3042c0 66.6 54 120.5 120.6 120.5h2517c66.6 0 120.6-53.9 120.6-120.5v-162.9"
				style={{
					fill: '#3b3e54',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M19835.1 2532.4h-3670.2v80.7c0 168.8 136.9 305.7 305.7 305.7h3058.8c168.8 0 305.7-136.9 305.7-305.7v-80.7"
				style={{
					fill: '#3b3e54',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<g
				clipPath="url(#a)"
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			>
				<path
					d="M16289.3 6031c0 944.8 765.9 1710.7 1710.7 1710.7 944.8 0 1710.7-765.9 1710.7-1710.7 0-944.7-765.9-1710.6-1710.7-1710.6-944.8 0-1710.7 765.9-1710.7 1710.6z"
					style={{
						fill: 'none',
						stroke: '#3b3e54',
						strokeWidth: 120,
						strokeLinecap: 'round',
						strokeLinejoin: 'round',
						strokeMiterlimit: 10,
						strokeDasharray: 'none',
						strokeOpacity: 1,
					}}
				/>
				<path
					d="m17574.6 7687.9 73.1-284.8M16829 7278l201.3-214.3M16373.1 6559.7l279.7-90.9M16292.7 6138.5l293.5-18.5M19707.3 6138.5l-293.5-18.5M19626.9 6559.7l-279.7-90.9M19171 7278l-201.3-214.3M18425.4 7687.9l-73.1-284.8"
					style={{
						fill: 'none',
						stroke: '#3b3e54',
						strokeWidth: 70,
						strokeLinecap: 'round',
						strokeLinejoin: 'round',
						strokeMiterlimit: 10,
						strokeDasharray: 'none',
						strokeOpacity: 1,
					}}
				/>
			</g>
			<path
				d="M13310.9 7351.9V6111h9378.2v1246.4"
				style={{
					fill: 'none',
					stroke: '#616478',
					strokeWidth: 180,
					strokeLinecap: 'round',
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
					strokeDasharray: 'none',
					strokeOpacity: 1,
				}}
				className={'tehtnica'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m10455.9 7512.3 2855-632.3 2855 632.3v15.3h-5710v-15.3"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M10455.9 7823.8v-296.2h5710v296.2h-5710M25544.1 7823.8h-5710v-296.2h5710v296.2"
				style={{
					fill: '#e3b69d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M19834.1 7527.6v-15.3l2855-632.3 2855 632.3v15.3h-5710M17518.5 6111c0 266 215.6 481.5 481.5 481.5s481.5-215.5 481.5-481.5c0-265.9-215.6-481.4-481.5-481.4s-481.5 215.5-481.5 481.4"
				style={{
					fill: '#f5ccb5',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14311.2 13044.3c0 455.1-379.4 821.6-839.2 800.4-413.6-19.1-747.9-357.1-762.8-770.8-9.1-251 97.4-477.3 270.4-630.1 105.7-93.3 163.8-229.4 163.8-370.4v-21.3c0-59.3 48.1-107.5 107.5-107.5h518c59.4 0 107.5 48.2 107.5 107.5v21.4c0 142.7 61.1 278.5 167.5 373.6 164 146.7 267.3 359.8 267.3 597.2"
				style={{
					fill: '#f7f5f2',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M13509.9 12986c-108.3-.3-257.1 77.8-263.9 203-9.4 174.2 236.8 162.4 185-32.8-60.8-228.8-327.1-92.4-327.1-92.4M13915.9 13063.8s-266.3-136.4-327.1 92.4c-51.8 195.2 194.4 207 185 32.8-6.8-125.2-155.6-203.3-263.9-203"
				style={{
					fill: 'none',
					stroke: '#585b6e',
					strokeWidth: 14.2719,
					strokeLinecap: 'butt',
					strokeLinejoin: 'miter',
					strokeMiterlimit: 10,
					strokeDasharray: 'none',
					strokeOpacity: 1,
				}}
				className={'bulb'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M13119.5 13056.6s293-459 313.7-1112M13900.3 13056.6s-293-459-313.7-1112"
				style={{
					fill: 'none',
					stroke: '#585b6e',
					strokeWidth: 14.2719,
					strokeLinecap: 'butt',
					strokeLinejoin: 'miter',
					strokeMiterlimit: 10,
					strokeDasharray: 'none',
					strokeOpacity: 1,
				}}
				className={'bulb'}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M13548.9 11405.6h-78c-70.8 0-128.2 57.4-128.2 128.2v316c0 55.2 44.7 99.9 99.9 99.9h134.6c55.2 0 99.9-44.7 99.9-99.9v-316c0-70.8-57.4-128.2-128.2-128.2"
				style={{
					fill: '#60647d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M13663.4 11493h-307c-75.1 0-136 60.9-136 136v318.1c0 1.4 1.2 2.6 2.6 2.6h573.8c1.4 0 2.6-1.2 2.6-2.6V11629c0-75.1-60.9-136-136-136"
				style={{
					fill: '#3b3e54',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M13807.168 11614.945h-597.2c-23.6 0-42.6 19-42.6 42.5s19 42.6 42.6 42.6h597.2c23.6 0 42.6-19.1 42.6-42.6s-19-42.5-42.6-42.5M13805.616 11764.344h-597.2c-23.6 0-42.6 19-42.6 42.5s19 42.6 42.6 42.6h597.2c23.6 0 42.6-19.1 42.6-42.6s-19-42.5-42.6-42.5"
				style={{
					fill: '#60647d',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15249.4 10456.1s-119.5 13.5-118.8 36.5l118.8 520.7 70.4 427.1 61.6-357.7-132-626.6"
				style={{
					fill: '#685f6a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15284.7 7948.2s28.3-96 11.3-101.6c-16.9-5.7-412.2-22.6-440.5-5.7-28.2 17 56.5 45.2 56.5 45.2s186.4 50.8 293.7 62.1c0 0 79 5.7 79 0"
				style={{
					fill: '#af7d61',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15339.5 9252.84c-22.6 45.19-48.2 67.78-90.4 67.78-46.3 0-83.4-38.38-81.8-84.67l44-1290.75c.7-20.4 17.4-36.5 37.8-36.5s37.1 16.1 37.8 36.5l1.9 55.8c72.4 883.41 118.4 1088.06 50.7 1251.84"
				style={{
					fill: '#af7d61',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15472.3 10394.9c-32.1 151.1-112.9 176.8-168.8 174.8-3.7.8-7.5 1.5-11.5 1.7-46.2 3.2-85.8-32.5-87.4-78.8l-44.6-1290.78c-.7-20.36 14.9-37.61 35.2-39.01 6.8-.46 13.3.93 19 3.71 46.2 12.49 82.5 49.43 93.4 97.02 56.9 247.84 206.6 934.76 164.7 1131.36"
				style={{
					fill: '#db957f',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15049.3 7929.7c41-18 109-29.8 186.1-29.8 24.6 0 48.3 1.2 70.5 3.5 5.1-34.9 7.4-75.6-9.5-77.5-29.9-3.5-459.7-16.5-462.3 3.4-4.9 39.4 110.4 77 215.2 100.4"
				style={{
					fill: '#3b3e54',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15967.2 7948.2s28.3-96 11.3-101.6c-16.9-5.7-412.3-22.6-440.5-5.7-28.2 17 56.5 45.2 56.5 45.2s186.3 50.8 293.7 62.1c0 0 79 5.7 79 0"
				style={{
					fill: '#af7d61',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15896.1 9256.49c-26.5 43.01-54 63.25-96 59.52-46.1-4.1-79.7-45.6-74-91.57l158-1281.84c2.5-20.2 20.5-34.8 40.8-33 20.3 1.8 35.5 19.4 34.4 39.7l-3 55.7c-6 886.43 21.8 1094.35-60.2 1251.49"
				style={{
					fill: '#af7d61',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15776.4 10418.3c-64.6 140.4-149 147.7-203.1 133.5-3.9 0-7.7-.2-11.6-.8-45.8-7.1-76.6-50.7-68-96.2l239.8-1269.02c3.7-20.02 22.7-33.43 42.8-30.33 6.8 1.03 12.8 3.82 17.8 7.78 42.3 22.32 69.6 66.32 69.8 115.16 1.1 254.28-3.6 957.31-87.5 1139.91"
				style={{
					fill: '#db957f',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15731.8 7929.7c41-18 109-29.8 186.1-29.8 24.6 0 48.3 1.2 70.5 3.5 5.1-34.9 7.4-75.6-9.6-77.5-29.8-3.5-459.7-16.5-462.2 3.4-5 39.4 110.4 77 215.2 100.4M15796.1 10474.6s133.7-603.12 100.3-1165.15c0 0 37.9-48.98 63-156.72 0 0-383.4-143.28-826.4-139.18 0 0-5.5 162.29 0 329.75 5.6 167.45 71.6 1149.3 71.6 1149.3l591.5-18"
				style={{
					fill: '#3b3e54',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14127.6 12221.5c14.7 26.8 16 58.8 3.5 86.7-31.9 71.5-96.6 204.3-142.8 218.1-63.5 19 4-224 131-320l8.3 15.2"
				style={{
					fill: '#af7d61',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14134.4 12297.6c157-90.4 468.1-337.7 539.3-427.7 59.2-74.8 12.9-109.6 11.5-111.6-16.9-23.9-71.7-28.9-98.3-6.5l-506.8 478.2 54.3 67.6"
				style={{
					fill: '#685f6a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15491.3 11969.7c105.9-9.1 86.7-98.1 87.2-100.8 6.1-31.3-38.9-74.3-77.6-78.7l-866.6-52.6c-13.8-2.2-17.9 20.7-20.6 34.4-.8 4.6-.4 9.2 1 13.3 4.6 32.6 35.3 63.4 66.9 74.9 164.4 59.9 671.9 121.4 809.7 109.5"
				style={{
					fill: '#685f6a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15808 10387.4c16-5.1 8.3 324-29.8 559.5 8.6 204.1-46.2 691.3-92.9 838.9-58.6 185.4-151.2 286.9-305.4 212.8-48.6-23.3-94.7-159.9-115.2-305.1-20.5-145.2-49.3-116 30.6-328.9 28.4-75.7-43-588.2-78.3-723.7-10.2-38.9-24.9-171.3-44.3-212.4 28.3-20.2 54.9-34.9 85.9-46.1 212.9-77.3 336.2 74 549.4 5"
				style={{
					fill: '#88aebc',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15502.6 12061.6s195.4 76.3 203.9 222.6c11.5 196.5-226.9 322.9-346.3 201-81-82.6-79.2-145.9-67.2-166.6 12.1-20.7 209.6-257 209.6-257"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m15545.5 12247.5-157.4 11.1c-1.6-21.6-12.5-226.8-2.5-303.7 6.4-23.6 45.9-33.5 88.1-22 38 10.3 65.1 34.3 65.6 56.2h.2c-6.1 46.2.7 183 6 258.4"
				style={{
					fill: '#af7d61',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15534.4 12224.5c-23.9-124.2-129.8-208.3-205.7-193.8-75.9 14.6-93.2 122.4-69.3 246.6 23.8 124.3 97.5 175.7 173.5 161.1 75.9-14.5 125.3-89.6 101.5-213.9"
				style={{
					fill: '#af7d61',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15340.8 12451.4s31.7-166.4 186.3-222.5c79.6-28.9 105.1 96.7 105.1 96.7l-78.9 118.8s-64.3 50.4-113.1 45c-4.2-.5-99.4-38-99.4-38"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15284.6 12355.7s138.5 50.7 158.8 99.1c20.4 48.4-50.8 42.1-50.8 42.1s-91.8-34.2-108-141.2M15649.3 12414.7s-165.6 126.9-55.2 281.5c110.4 154.5 303 97.2 347.8-22.1 49.6-132.5-16.6-215.3-71.8-253.9-55.2-38.7-154.5-44.2-220.8-5.5"
				style={{
					fill: '#2d334a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15595.6 12178.9c-12.3-28.9-56.8-53.6-77.7-44.7-21 9-16.2 34.6-3.9 63.5 12.4 29 40.9 48.7 61.8 39.8 20.9-8.9 32.1-29.6 19.8-58.6"
				style={{
					fill: '#af7d61',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15600.7 11975.3s-57.5-90.3-182.1-115.1c0 0 135.1-1201.6 96.4-1346.2 0 0 256.8-3.5 311.7-21.4 0 0-34.3 795.5-56.6 944.1-22.3 148.6-75 430.9-169.4 538.6"
				style={{
					fill: '#685f6a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M16198.4 10440.8c-3-14.5-6.3-28.7-10.3-42.6-14.9-54.9-36.5-106.3-63.8-153.6-14.5-25.4-30.8-49.7-48.6-72.7-35.4-46-76.6-86.7-122.2-121.5-23.3-17.7-47.6-33.8-73-48.3-48.1-27.32-99.7-48.78-153.8-63.39-27.9-7.62-56.7-13.47-85.8-17.07-56.2-7.44-114-7.58-172.3.53-14.4 1.73-28.7 4.26-43.2 7.21-14.5 2.95-28.7 6.25-42.6 10.26-55 14.97-106.4 36.56-153.6 63.86-25.5 14.5-49.8 30.8-72.8 48.6-46 35.4-86.6 76.6-121.4 122.2-17.7 23.3-33.8 47.6-48.3 73-27.4 48.1-48.8 99.7-63.4 153.7-7.7 28-13.5 56.8-17.1 85.9-7.4 56.2-7.6 114 .5 172.3 1.7 14.3 4.3 28.7 7.2 43.2 3 14.5 6.3 28.7 10.3 42.6 15 54.9 36.5 106.4 63.8 153.6 14.6 25.5 30.8 49.8 48.6 72.7 35.4 46.1 76.7 86.7 122.3 121.5 23.2 17.7 47.6 33.8 73 48.3 48 27.3 99.7 48.8 153.7 63.4 27.9 7.6 56.7 13.5 85.9 17.1 56.1 7.4 113.9 7.6 172.2-.5 14.4-1.8 28.8-4.3 43.3-7.2 14.5-3 28.7-6.3 42.6-10.3 54.9-15 106.3-36.6 153.6-63.9 25.4-14.5 49.7-30.8 72.7-48.5 46-35.4 86.7-76.7 121.5-122.3 17.7-23.3 33.8-47.6 48.2-73 27.4-48 48.9-99.7 63.5-153.7 7.6-28 13.4-56.8 17-85.9 7.5-56.1 7.6-113.9-.5-172.3-1.7-14.3-4.3-28.7-7.2-43.2"
				style={{
					fill: '#f8dcba',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M14998.6 10685.2c62.7 307.9 363.2 506.6 671.1 443.9 307.9-62.7 506.6-363.1 443.9-671-62.7-307.9-363.1-506.67-671-444-307.9 62.7-506.7 363.2-444 671.1"
				style={{
					fill: '#f1b770',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15030 10678.8c59.2 290.5 342.7 478.1 633.3 418.9 290.5-59.1 478.1-342.7 418.9-633.2-59.1-290.6-342.7-478.16-633.2-419-290.6 59.2-478.2 342.7-419 633.3"
				style={{
					fill: '#f8dcba',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="m15288.8 10377.7-91.6-38.9-49.4 116.4 87.5 37.1c-30.1 84.6-41.8 174.2-32.3 236.6l168.5-2.4c-9-68.1 1.2-149.5 28.2-213.1 23.5-55.2 43.4-70.1 63.2-61.7 72.7 30.8-121.6 325.3 93.8 416.8 93.3 39.6 200.4 5.2 276.9-122.1l89.9 38.2 49.4-116.4-88.3-37.4c20.2-63.6 29.7-129.6 23.3-187.9l-166-1.3c4.7 69.2-4 128.8-25.4 179.1-24.2 57-48.4 68.1-68.2 59.7-69.3-29.5 124.1-324.3-88.9-414.7-89.1-37.8-194-6.4-270.6 112"
				style={{
					fill: '#f1b770',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15678.2 11850.9c-79.2 65.7-129.4-9.7-131.7-11.2-26.5-17.7-26.3-78.4-2.9-107.7l556.6-626c7.9-11 27 2.3 38.7 10.1 3.9 2.6 6.8 6 8.8 9.9 20.1 25.9 21 68.3 7.5 97.9-70 153.6-374 541.7-477 627"
				style={{
					fill: '#685f6a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15608.9 10708.7c17.6-25 22.5-56.7 13.2-85.8-23.6-74.6-72.9-213.9-117.3-232.8-61-26-21.3 223.1 94.1 332.8l10-14.2"
				style={{
					fill: '#af7d61',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
			<path
				d="M15631.6 10650.2c152.6 97.7 451.7 359.3 518.6 452.7 55.5 77.4 7.7 110 6.2 112-18 23-73 25.5-98.5 1.9l-483.7-501.6 57.4-65"
				style={{
					fill: '#685f6a',
					fillOpacity: 1,
					fillRule: 'nonzero',
					stroke: 'none',
				}}
				transform="matrix(.13333 0 0 -.13333 -1824.058 971.625)"
			/>
		</svg>
	);
};

export default Cover;
